/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RateMealSelectionRequest
 */
export interface RateMealSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof RateMealSelectionRequest
     */
    'rating'?: RateMealSelectionRequestRatingEnum;
}

export const RateMealSelectionRequestRatingEnum = {
    Disliked: 'DISLIKED',
    Ok: 'OK',
    Liked: 'LIKED'
} as const;

export type RateMealSelectionRequestRatingEnum = typeof RateMealSelectionRequestRatingEnum[keyof typeof RateMealSelectionRequestRatingEnum];


